<div class="edit-block mat-elevation-z1">
    <h2>{{ 'Comment' | translate }}</h2>

    <mat-form-field color="primary">
        <textarea matInput
                  cdkTextareaAutosize
                  maxlength="2500"
                  [placeholder]="'Comment' | translate"
                  [(ngModel)]="data.data.comment"
                  (ngModelChange)="onCommentChange($event)">
        </textarea>
    </mat-form-field>
</div>
